import { DETAILS_BREADCRUMB, BREADCRUMBS } from '@app/store/constants';
import { IBreadcrumb } from '@app/models';

export function addDetailsBreadcrumb(breadcrumb: string) {
    return {
        payload: breadcrumb,
        type: DETAILS_BREADCRUMB
    };
}

export function removeDetailsBreadcrumb() {
    return {
        payload: '',
        type: DETAILS_BREADCRUMB
    };
}

export function customBreadcrumbs(breadcrumbs: IBreadcrumb[]) {
    return {
        payload: breadcrumbs,
        type: BREADCRUMBS
    };
}
